module.exports = __webpack_public_path__ + "media/landing_page/small_top_background-e0b4d933.png";